import React from 'react';
import { v4 as uuidv4 } from 'uuid';
import PropTypes from 'prop-types';

import s from 'src/components/JobDatasheet/JobDatasheetForm/JobDatasheetForm.styles';

export const QuestionTableHeader = ({ question, getOptionLabel, isError }) => {
  const {
    tableSettings: { columns, maximizeWidth },
  } = question;

  let translationIndex = 0;
  return (
    <s.TableColumns maximizeWidth={maximizeWidth}>
      {columns.map(column => {
        const label = getOptionLabel(translationIndex, column.name);        
        let {options} = column;
        if(column.type === "dependentDropdown"){
          options = column.dependentDropdownOptions;
        }
        translationIndex += 1 + (options || []).length;
        return (
         <s.TableColumn key={uuidv4()} isError={isError}>{label}</s.TableColumn>
        );
      })}
    </s.TableColumns>
  );
};

QuestionTableHeader.propTypes = {
  question: PropTypes.shape({
    tableSettings: {
      columns: PropTypes.arrayOf(
        PropTypes.shape({
          name: PropTypes.string,
          type: PropTypes.string,
        }),
      ),
    },
  }),
  getOptionLabel: PropTypes.func,
};

QuestionTableHeader.defaultProps = {
  getOptionLabel: (index, defaultValue) => defaultValue,
};
